import { StoreWorkshopStats } from '@euler/model/StoreWorkshopStats';
import { TaskListItem } from '@euler/model/TaskListItem';
import { memo, useMemo } from 'react';
import { View } from 'react-native';
import { countStages, kBoardStages } from '../../functions/countStages';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';
import { MetricCard } from './MetricCard';

/**
 * The counts across the top: what is in the shop and today's orders from
 * the server, the stages from the open tasks themselves.
 */
export const MetricStrip = memo(
  ({
    tasks,
    stats,
  }: {
    /** Null while the board loads. */
    tasks: TaskListItem[] | null;
    stats: StoreWorkshopStats | null;
  }) => {
    const u = useBoardUnit();
    const stages = useMemo(() => (tasks ? countStages(tasks) : null), [tasks]);
    return (
      <View style={{ flexDirection: 'row', gap: u(16) }}>
        <MetricCard
          label="在店未完工"
          value={tasks?.length ?? null}
          color={colors.active}
        />
        <MetricCard label="今日新建单" value={stats?.orderCount ?? null} />
        <MetricCard
          label="今日完工"
          value={stats?.finishedTaskCount ?? null}
          color={colors.done}
        />
        {kBoardStages.map(stage => (
          <MetricCard
            key={stage}
            label={stage}
            value={stages?.[stage] ?? null}
          />
        ))}
      </View>
    );
  },
);
